/**
 * Root RTK Query API.
 *
 * Features inject their own endpoints via `baseApi.injectEndpoints(...)` (see
 * src/features/recommendations/api). This keeps endpoint code co-located with its
 * feature and lets those chunks code-split with the feature rather than loading
 * on boot. Define shared tag types here for cache invalidation.
 */
import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from './interceptors';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Portfolio', 'Recommendation', 'CostAdvice', 'Notification'],
  endpoints: () => ({}),
});
